import React, { ReactNode, HTMLAttributes } from 'react';

import Button from '../../../Button/Button';

export interface PrimaryActionProps extends HTMLAttributes<HTMLButtonElement> {
  actionIsLoading?: boolean;
  callback?: (event?: any) => void;
  label?: ReactNode;
  size?: 'wide' | 'full';
  type?: 'primary' | 'danger';
  formId?: string | undefined;
}

function PrimaryAction(props: PrimaryActionProps) {
  const { callback, type, size, actionIsLoading, label, formId } = props;

  return (
    <Button
      data-disabled={actionIsLoading}
      data-testid={props['data-testid']}
      form={formId}
      isDisabled={actionIsLoading}
      onClick={callback}
      role="button"
      size={size}
      tabIndex={0}
      type={type}
      htmlType={formId === undefined ? 'button' : 'submit'}
    >
      {label}
    </Button>
  );
}

PrimaryAction.defaultProps = {
  size: 'wide',
  type: 'primary',
};

export default PrimaryAction;
